import { Call, Strain } from "@ravalmatic/bridge-engine/core";
import { BiddingCell, BiddingCellState } from "./BiddingCell";

export class BiddingRow extends Phaser.GameObjects.Container {

    private static readonly CELL_SCALE = 1;
    private static readonly CELL_SPACING = 82;
    private static readonly FIRST_CELL_X = -164;

    public readonly level: number;

    private readonly bidCells: BiddingCell[];

    constructor(scene: Phaser.Scene, level: number, onSelected: (call: Call) => void) {

        super(scene);

        this.level = level;

        this.bidCells = Array.from({ length: 5 }, (_, index) => {
            const cell = new BiddingCell(scene, level, index as Strain, onSelected);
            cell.setScale(BiddingRow.CELL_SCALE);
            cell.setPosition(BiddingRow.FIRST_CELL_X + index * BiddingRow.CELL_SPACING, 0);
            this.add(cell);
            return cell;
        });
    }

    public refresh(legalCalls: readonly Call[], selectedCall: Call | null, enabled: boolean): void {

        this.bidCells.forEach(cell => {
            const isLegal = legalCalls.includes(cell.call);
            cell.setLegal(isLegal);

            if (cell.call === selectedCall) {
                cell.setState(BiddingCellState.SELECTED);
            } else if (enabled && isLegal) {
                cell.setState(BiddingCellState.ENABLE);
            } else {
                cell.setState(BiddingCellState.DISABLED);
            }
        });
    }
}
